import React, { useEffect } from 'react'
import { Block } from '../../components/Component';
import Head from '../../layout/head/Head';
import PageContainer from '../../layout/page-container/PageContainer';
import { handleWebsiteReminderLink } from '../../app/api';
import { useParams } from 'react-router-dom';

const WebsiteReminderLink = () => {
    let { uid, web_code } = useParams();

    const websiteReminderLink = async () => {

        let response = await handleWebsiteReminderLink({ uid: atob(uid), web_code: atob(web_code) });

        if (response.code == 301) {
            setTimeout(() => {
                window.location.href = "https://publisher.7searchppc.in/website-link-expire";
            }, 1000);
        } else if (response.code == 302) {
            setTimeout(() => {
                window.location.href = "https://publisher.7searchppc.in/websites";
            }, 1000);
        }
    }

    useEffect(() => {
        websiteReminderLink();
    }, []);

    return (
        <React.Fragment>
            <Head title="Website Verify Link" />
            <PageContainer>
                <Block className="nk-block-middle nk-auth-body  wide-xs">

                    <h4 className='text-center text-primary'>Please wait...</h4>
                </Block>
            </PageContainer>
        </React.Fragment>
    );
};

export default WebsiteReminderLink;